import DateInput, { COMPACT_DATE_INPUT_CLASS } from "../../DateInput";
import { formatAppDate, parseDbDateTime } from "../../../utils/appDateTime";
import FilterField from "../fields/FilterField";
import FilterMultiSelect from "../fields/FilterMultiSelect";
import FilterSearchableSelect from "../fields/FilterSearchableSelect";
import FilterSelect from "../fields/FilterSelect";
import FilterToggle from "../fields/FilterToggle";
import FilterSortGroup from "../fields/FilterSortGroup";
import formatGroupedValues from "../utils/formatGroupedValues";

export const SORT_DIRECTION_OPTIONS = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

export function resolveOptionLabel(options, value) {
  const match = (options || []).find((o) => String(o.value) === String(value));
  return match?.label || String(value || "");
}

export function dateChipLabel(value) {
  if (!value) return "";
  const d = parseDbDateTime(`${value}T12:00:00Z`);
  if (!d) return value;
  return formatAppDate(d, { emptyValue: value });
}

export function FieldWrapper({ fieldId, label, focusedFieldId, onFocusClear, children }) {
  return (
    <FilterField
      id={fieldId}
      label={label}
      focusedFieldId={focusedFieldId}
      onFocusClear={onFocusClear}
    >
      {children}
    </FilterField>
  );
}

export function CompactDateInput({ id, value, onChange, className, min, max, ...rest }) {
  return (
    <DateInput
      id={`${id}-control`}
      value={value || ""}
      onChange={onChange}
      className={className || COMPACT_DATE_INPUT_CLASS}
      min={min}
      max={max}
      {...rest}
    />
  );
}

export function CompactTextInput({ id, value, onChange, onFocus, placeholder, disabled = false }) {
  return (
    <input
      id={`${id}-control`}
      type="text"
      value={value || ""}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      className="h-8 w-full rounded border border-gray-200 bg-white px-2 text-xs text-gray-800 transition-colors placeholder:text-gray-400 hover:border-gray-300 focus:border-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-300 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400"
    />
  );
}

export function DropdownList({ items = [], onSelect, emptyLabel = "No options" }) {
  return (
    <div className="absolute left-0 right-0 z-[120] mt-1 max-h-56 overflow-y-auto rounded border border-gray-200 bg-white py-1 text-xs shadow-lg">
      {items.length > 0 ? (
        items.map((item) => (
          <button
            key={String(item.id ?? item.value)}
            type="button"
            onClick={() => onSelect(item)}
            className="block w-full px-2 py-1.5 text-left text-gray-700 hover:bg-gray-50"
          >
            <span className="block truncate font-medium">{item.name ?? item.label}</span>
            {item.full_address ? (
              <span className="block truncate text-[10px] text-gray-500">
                {item.full_address}
              </span>
            ) : null}
          </button>
        ))
      ) : (
        <div className="px-2 py-3 text-center text-[10px] italic text-gray-400">
          {emptyLabel}
        </div>
      )}
    </div>
  );
}

export {
  FilterMultiSelect,
  FilterSearchableSelect,
  FilterSelect,
  FilterToggle,
  FilterSortGroup,
  formatGroupedValues,
};
